import { Skeleton, Stack } from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import { useCarrierShipmentPageContext, useTfc } from "hooks";
import { carrierHasBookingWriteAccess } from "utils";

import { TfcDisplay } from "./components/TfcDisplay";
import { TfcSubmitForm } from "./components/TfcSubmitForm";

interface TotalFreightCostSectionProps {
  dividerComponent: JSX.Element;
}

export function TotalFreightCostSection(props: TotalFreightCostSectionProps) {
  const { dividerComponent } = props;
  const { shipment } = useCarrierShipmentPageContext();
  const shipmentId = shipment?.info?.id ?? null;
  const { data: tfcData, loading, error, mutate } = useTfc({ shipmentId });

  if (!shipment) return null;
  if (shipment.shipment_status !== "DELIVERED") return null;
  if (shipment.info.type !== "SINGLE") return null;
  if (!carrierHasBookingWriteAccess(shipment)) return null;

  return (
    <Stack direction="column" mb="1.5rem">
      {dividerComponent}

      {loading && (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width="100%" height={60} />
          <Skeleton variant="rounded" width="100%" height={200} />
          <Skeleton variant="rounded" width="40%" height={36} />
        </Stack>
      )}

      <ErrorTypography error={error} />

      {!loading && tfcData?.exists && (
        <TfcDisplay
          tfcData={tfcData}
          shipment={shipment}
          onTfcUpdated={() => {
            mutate();
          }}
        />
      )}

      {!loading &&
        tfcData &&
        !tfcData.exists &&
        tfcData.available_operations.includes("SUBMIT") && (
          <TfcSubmitForm
            tfcData={tfcData}
            shipment={shipment}
            onTfcCreated={mutate}
          />
        )}
    </Stack>
  );
}
